import axios from '@/http/axios'
import {createCancelTokenHandler, makeQuery} from '../axios/utils'

const cancelTokenHandlerObject = {
  getSupportTickets: createCancelTokenHandler('getSupportTickets')
}

// support tickets requests

export function getTickets (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${queries.join('&')}`

  return axios({
    url: `v1/tickets${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getSupportTickets'].handleRequestCancellation().token
  })
}

export function getTicket (id, loading) {

  return axios({
    url: `v1/tickets/${id}`,
    loading,
    method: 'get'
  })
}

export function insertTicket (payload) {

  return axios({
    url: 'v1/tickets',
    data: payload,
    method: 'post'
  })
}

export function sendMessageTicket (id, payload) {

  return axios({
    url: `v1/tickets/${id}/messages`,
    data: payload,
    method: 'post'
  })
}

export function sendTicketToService (id) {

  return axios({
    url: `v1/tickets/${id}/send`,
    method: 'post'
  })
}

export function completeTicket (id) {

  return axios({
    url: `v1/tickets/${id}/complete`,
    method: 'post'
  })
}
